import { oneOf } from "prop-types";
import { PAYMENT_STATUSES_LIST } from "../../constants";

const PaymentStatusType = oneOf(PAYMENT_STATUSES_LIST);

export default PaymentStatusType;
